import type { IErrorApiProps } from '../../../types';
import { EApiType, EDisplayType } from './CommonConstants';
import { EMessageType } from './ToastMessageConstants';

export enum EErrorCode {
  NetworkError = 'ERR_NETWORK',
  WiInvalid = 'WiInvalid',
}

export enum EHttpCode {
  Status204 = 204,
  Status400 = 400,
  Status401 = 401,
  Status403 = 403,
  Status404 = 404,
}

/**
 * Global HTTP error message keys (ultimate fallback).
 * If an action's config doesn't define a message for a status code,
 * this map is used. Maps to 'errorMessages.http.{code}' in translations.
 */
export const GlobalHttpErrorMessageKey = 'messages.http';

/**
 * Configuration map for error feedback per API action.
 * To change behavior: update messages here. No changes to handleError needed.
 */
export const errorConfig: Partial<Record<EApiType, IErrorApiProps>> = {
  [EApiType.SaveProperties]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'messages.submit.error' } },
  },
  [EApiType.SaveMarketAssociations]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'messages.submit.error' } },
  },
  [EApiType.SendNotification]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'request.failed' } },
    messagePlaceholder: 'consumers',
  },
  [EApiType.Download]: {
    displayAs: EDisplayType.Dialog,
    messages: { default: { message: 'request.failed' } },
  },
  [EApiType.GetPropertyAssociations]: {
    displayAs: EDisplayType.Toast,
    messages: {
      [EHttpCode.Status204]: {
        message: 'messages.pdm.noPropertyAssociationFound',
        type: EMessageType.Info,
        toastPosition: 'top-center',
      },
      default: {
        message: 'messages.error.fetchPropertyAssociations',
        type: EMessageType.Error,
        toastPosition: 'top-center',
      },
    },
  },
};
